<template>
    <div>
        <h4 class="mb-6">Adopt worker</h4>
        <div class="vx-row">
            <div class="vx-col lg:w-2/3 md:w-1/2 w-full">

                <vx-card title="Parameters" id="inputDiv"  class="vs-con-loading__container">

                    <div class="vx-row">
                        <div class="vx-col lg:w-1/2 w-full">
                            <p class="mt-6">Name</p>
                            <vs-input v-model="worker['name']" class="w-full"></vs-input>
                        </div>
                        <div class="vx-col lg:w-1/2 w-full">
                            <p class="mt-6">Location</p>
                            <vs-select autocomplete class="w-full" v-model="worker['location_id']">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in locations" />
                            </vs-select>
                        </div>
                    </div>

                    <div class="vx-row mt-6">
                        <div class="vx-col lg:w-1/3 w-full mt-6 mb-6">
                            <h4>Input template</h4>
                            <vs-select autocomplete class="w-full" v-model="worker['in_template'].id">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in inputTemplates" />
                            </vs-select>
                            <div v-if="inputTemplateMap[worker['in_template'].id] && inputTemplateMap[worker['in_template'].id].params.length > 0">
                                <h6 class="mt-6">Template parameters</h6>
                                <div class="w-full vx-row mb-4" :key="item.key" v-for="item in inputTemplateMap[worker['in_template'].id].params">
                                    <div class="vx-col w-1/2">
                                        <vs-checkbox class="mt-3" v-model="enabledInputTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                                    </div>
                                    <div class="vx-col w-1/2">
                                        <vs-input v-if="enabledInputTemplateParameters.includes(item.key)" v-model="inputTemplateParams[item.key]" class="w-full"></vs-input>
                                        <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="vx-col lg:w-1/3 w-full mt-6 mb-6">
                            <h4>Work template</h4>
                            <vs-select autocomplete class="w-full" v-model="worker['work_template'].id">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTemplates" />
                            </vs-select>
                            <div v-if="workTemplateMap[worker['work_template'].id] && workTemplateMap[worker['work_template'].id].params.length > 0">
                                <h6 class="mt-6">Template parameters</h6>
                                <div class="w-full vx-row mb-4" :key="item.key" v-for="item in workTemplateMap[worker['work_template'].id].params">
                                    <div class="vx-col w-1/2">
                                        <vs-checkbox class="mt-3" v-model="enabledWorkTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                                    </div>
                                    <div class="vx-col w-1/2">
                                        <vs-input v-if="enabledWorkTemplateParameters.includes(item.key)" v-model="workTemplateParams[item.key]" class="w-full"></vs-input>
                                        <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="vx-col lg:w-1/3 w-full mt-6 mb-6">
                            <h4>Output template</h4>
                            <vs-select autocomplete class="w-full" v-model="worker['out_template'].id">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in outputTemplates" />
                            </vs-select>
                            <div v-if="outputTemplateMap[worker['out_template'].id] && outputTemplateMap[worker['out_template'].id].params.length > 0">
                                <h6 class="mt-6">Template parameters</h6>
                                <div class="w-full vx-row mb-4" :key="item.key" v-for="item in outputTemplateMap[worker['out_template'].id].params">
                                    <div class="vx-col w-1/2">
                                        <vs-checkbox class="mt-3" v-model="enabledOutputTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                                    </div>
                                    <div class="vx-col w-1/2">
                                        <vs-input v-if="enabledOutputTemplateParameters.includes(item.key)" v-model="outputTemplateParams[item.key]" class="w-full"></vs-input>
                                        <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <vs-divider/>

                    <vs-button :disabled="!inputValid || worker.license_disabled" icon-pack="feather" icon="icon-award" color="success" class="mt-6; mr-1" @click="adoptWorker">Adopt</vs-button>

                </vx-card>

            </div>

            <div class="vx-col lg:w-1/3 md:w-1/2 w-full md:order-last order-first mb-6">
                <vx-card title="Worker specifications" id="dataDiv"  class="vs-con-loading__container">
                    <vx-card class="mb-6 p-0" card-background="warning" content-color="#fff" v-if="worker.license_disabled">
                        <div class="vx-row">
                            <div class="vx-col w-1/12">
                                <feather-icon style="color:#fff" icon="AlertTriangleIcon" color="#fff" class="mt-2"/>
                            </div>
                            <div class="vx-col w-11/12">
                                <p>Cannot adopt worker! <br>License limit reached</p>
                            </div>
                        </div>

                    </vx-card>
                    <h4>Docker version</h4>
                    <p>{{worker.docker_version}}</p>
                    <h4 class="mt-6">CPU</h4>
                    <p>{{worker.cpu}}</p>
                    <h4 class="mt-6">RAM</h4>
                    <p>{{(worker.ram / 1000000000).toFixed(2)}}GB</p>
                    <h4 class="mt-6">Swap</h4>
                    <p>{{(worker.swap / 1000000000).toFixed(2)}}GB</p>
                    <h4 class="mt-6">IP</h4>
                    <p>{{worker.ip}}</p>
                    <h4 class="mt-6">Port</h4>
                    <p>{{worker.port}}</p>
                    <h4 class="mt-6">GPUs</h4>
                    <div :key="data.uuid" v-for="(data) in worker.gpu">
                        <h6 class="mt-3">{{data.name}}</h6>
                        <div class="ml-6 mb-6">
                            <p><b>Total memory: </b>{{(data.total_memory/1000).toFixed(2)}}GB</p>
                            <p><b>Driver version: </b>{{data.driver_version}}</p>
                            <p><b>VBios version: </b>{{data.v_bios_version}}</p>
                            <p><b>Serial: </b>{{data.serial_number}}</p>
                            <p><b>UUID: </b>{{data.uuid}}</p>

                        </div>
                    </div>
                </vx-card>
            </div>

        </div>
    </div>
</template>
<script>

    export default {
        data() {
            return {

                worker: {
                    name: '',
                    location_id: 0,
                    docker_version: '',
                    cpu: '',
                    ram: '',
                    swap: '',
                    ip: '',
                    port: '',
                    gpu: '',
                    in_template: {},
                    work_template: {},
                    out_template: {}
                },

                locations: [],

                inputTemplates: [],
                workTemplates: [],
                outputTemplates: [],

                enabledInputTemplateParameters: [],
                inputTemplateParams: {},

                enabledWorkTemplateParameters: [],
                workTemplateParams: {},

                enabledOutputTemplateParameters: [],
                outputTemplateParams: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#inputDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.worker = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const locationsPromise = this.$http.get('/api/management/v1/location/')
                locationsPromise.then(function(response) {
                    thisIns.locations = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const inputTemplatePromise = this.$http.get('/api/management/v1/template/?type=0')
                inputTemplatePromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const workTemplatePromise = this.$http.get('/api/management/v1/template/?type=1')
                workTemplatePromise.then(function(response) {
                    thisIns.workTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const outputTemplatePromise = this.$http.get('/api/management/v1/template/?type=2')
                outputTemplatePromise.then(function(response) {
                    thisIns.outputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, locationsPromise, inputTemplatePromise, workTemplatePromise, outputTemplatePromise]).then(function() {
                    if (thisIns.locations.length > 0) {
                        thisIns.worker.location_id = thisIns.locations[0].id
                    }

                    if (thisIns.inputTemplates.length > 0) {
                        thisIns.worker.in_template.id = thisIns.inputTemplates[0].id
                    }

                    if (thisIns.workTemplates.length > 0) {
                        thisIns.worker.work_template.id = thisIns.workTemplates[0].id
                    }

                    if (thisIns.outputTemplates.length > 0) {
                        thisIns.worker.out_template.id = thisIns.outputTemplates[0].id
                    }
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#inputDiv > .con-vs-loading')
                })
            },
            adoptWorker() {
                this.$vs.loading({
                    container: '#inputDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const inputTemplateParams = []
                for (let i = 0; i < this.enabledInputTemplateParameters.length; i++) {
                    if (this.inputTemplateParams.hasOwnProperty(this.enabledInputTemplateParameters[i])) {
                        inputTemplateParams.push({
                            key: this.enabledInputTemplateParameters[i],
                            value: this.inputTemplateParams[this.enabledInputTemplateParameters[i]]
                        })
                    }
                }

                const workTemplateParams = []
                for (let i = 0; i < this.enabledWorkTemplateParameters.length; i++) {
                    if (this.workTemplateParams.hasOwnProperty(this.enabledWorkTemplateParameters[i])) {
                        workTemplateParams.push({
                            key: this.enabledWorkTemplateParameters[i],
                            value: this.workTemplateParams[this.enabledWorkTemplateParameters[i]]
                        })
                    }
                }

                const outputTemplateParams = []
                for (let i = 0; i < this.enabledOutputTemplateParameters.length; i++) {
                    if (this.outputTemplateParams.hasOwnProperty(this.enabledOutputTemplateParameters[i])) {
                        outputTemplateParams.push({
                            key: this.enabledOutputTemplateParameters[i],
                            value: this.outputTemplateParams[this.enabledOutputTemplateParameters[i]]
                        })
                    }
                }

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/worker', {
                    name: this.worker.name,
                    adoption_key: this.$route.params.id,
                    location_id: this.worker.location_id,
                    in_template: {
                        id: Number(this.worker.in_template.id),
                        params: inputTemplateParams
                    },
                    work_template: {
                        id: Number(this.worker.work_template.id),
                        params: workTemplateParams
                    },
                    out_template: {
                        id: Number(this.worker.out_template.id),
                        params: outputTemplateParams
                    }
                })

                addPromise.then(function(response) {
                    thisIns.$printSuccess('Worker added')
                    thisIns.$vs.loading.close('#inputDiv > .con-vs-loading')
                    thisIns.$router.push('/worker/adopt/' + response.data.id + '/status')
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#inputDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            inputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            workTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.workTemplates.length; i++) {
                    templatesMap[this.workTemplates[i].id] = this.workTemplates[i]
                }

                return templatesMap
            },
            outputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.outputTemplates.length; i++) {
                    templatesMap[this.outputTemplates[i].id] = this.outputTemplates[i]
                }

                return templatesMap
            },
            inputValid() {
                if (this.worker.name.length === 0) return false

                if (this.worker.location_id === 0 || this.worker.in_template.id === 0 || this.worker.work_template.id === 0 || this.worker.out_template.id === 0) return false

                return true
            }
        },
        watch: {
            'worker.in_template.id'() {
                if (!this.inputTemplateMap[this.worker.in_template.id]) return
                this.enabledInputTemplateParameters = []
                for (let i = 0; i < this.inputTemplateMap[this.worker.in_template.id].params.length; i++) {
                    this.$set(this.inputTemplateParams, this.inputTemplateMap[this.worker.in_template.id].params[i].key, this.inputTemplateMap[this.worker.in_template.id].params[i].default)
                }
            },
            'worker.work_template.id'() {
                if (!this.workTemplateMap[this.worker.work_template.id]) return
                this.enabledWorkTemplateParameters = []
                for (let i = 0; i < this.workTemplateMap[this.worker.work_template.id].params.length; i++) {
                    this.$set(this.workTemplateParams, this.workTemplateMap[this.worker.work_template.id].params[i].key, this.workTemplateMap[this.worker.work_template.id].params[i].default)
                }
            },
            'worker.out_template.id'() {
                if (!this.outputTemplateMap[this.worker.out_template.id]) return
                this.enabledOutputTemplateParameters = []
                for (let i = 0; i < this.outputTemplateMap[this.worker.out_template.id].params.length; i++) {
                    this.$set(this.outputTemplateParams, this.outputTemplateMap[this.worker.out_template.id].params[i].key, this.outputTemplateMap[this.worker.out_template.id].params[i].default)
                }
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
